import { Component, Input, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { BannerHomeItem, BannerHomePromoItem } from '../../models/mocks/banners-home.mock';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LoggedUserStateService } from '@frontend/unhideschool/app/core/services/legacy/logged-user.state';

@Component({
  selector: 'unh-banners-home',
  templateUrl: './banners-home.component.html',
  styleUrls: ['./banners-home.component.scss']
})
export class BannersHomeComponent implements OnInit {
  private _hasActivePromo = false;
  actualpromo = 'jornadailustrador';

  @Input() banners: BannerHomeItem[];
  @Input() promobanners: BannerHomePromoItem[];

  @Input()
  set hasActivePromo(val: boolean) {
    this._hasActivePromo = val;
  }
  get hasActivePromo(): boolean {
    return this._hasActivePromo;
  }

  swiperConfigsBanners: SwiperConfigInterface = {
    slidesPerView: 1,
    pagination: {
      el: '.banners-pagination',
    },
    keyboard: false,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    }
  };


  isMobile: boolean;

  isSubscribed: boolean;

  constructor(
    public luss: LoggedUserStateService,
    public router: Router,
    public bkos: BreakpointObserver
  ) { }

  ngOnInit() {
    this.bkos
      .observe('(max-width: 480px)')
      .subscribe((bo) => (this.isMobile = bo.matches));

    if (this.luss.subscribed) {
      this.banners = this.banners.filter(banner => banner.showToSubscribed);
    }

    this.isSubscribed = this.luss.subscribed;
  }
}
